import { TIME_TYPE, YULI_QUALITY_TYPE } from "./type";

/** passcard收益表*/
export const PASSCARD_INCOME_MAP = {
  [YULI_QUALITY_TYPE.WHITE]: {
    [TIME_TYPE.days6]: 0,
    [TIME_TYPE.days16]: 0,
    [TIME_TYPE.days30]: 0,
    [TIME_TYPE.days60]: 1,
  },
  [YULI_QUALITY_TYPE.GREEN]: {
    [TIME_TYPE.days6]: 0,
    [TIME_TYPE.days16]: 1,
    [TIME_TYPE.days30]: 2,
    [TIME_TYPE.days60]: 5,
  },
  [YULI_QUALITY_TYPE.BLUE]: {
    [TIME_TYPE.days6]: 1,
    [TIME_TYPE.days16]: 3,
    [TIME_TYPE.days30]: 6,
    [TIME_TYPE.days60]: 15,
  },
  [YULI_QUALITY_TYPE.PURPLE]: {
    [TIME_TYPE.days6]: 3,
    [TIME_TYPE.days16]: 9,
    [TIME_TYPE.days30]: 18,
    [TIME_TYPE.days60]: 45,
  },
  [YULI_QUALITY_TYPE.GOLDEN]: {
    [TIME_TYPE.days6]: 9,
    [TIME_TYPE.days16]: 27,
    [TIME_TYPE.days30]: 54,
    [TIME_TYPE.days60]: 135,
  },
};

/** art收益表*/
export const ART_INCOME_MAP = {
  [YULI_QUALITY_TYPE.WHITE]: {
    1: 0.86,
    2: 0.87,
    3: 0.87,
    4: 0.88,
    5: 0.89,
    6: 0.89,
    7: 0.9,
    8: 0.91,
    9: 0.91,
    10: 0.92,
    11: 0.93,
    12: 0.94,
    13: 0.95,
    14: 0.96,
    15: 0.97,
    16: 0.98,
    17: 0.99,
    18: 1,
    19: 1.01,
    20: 1.02,
    21: 1.03,
    22: 1.04,
    23: 1.06,
    24: 1.07,
    25: 1.08,
    26: 1.1,
    27: 1.11,
    28: 1.12,
    29: 1.14,
    30: 1.15,
    31: 1.17,
    32: 1.19,
    33: 1.2,
    34: 1.22,
    35: 1.24,
    36: 1.25,
    37: 1.27,
    38: 1.29,
    39: 1.31,
    40: 1.33,
    41: 1.35,
    42: 1.37,
    43: 1.39,
    44: 1.41,
    45: 1.43,
    46: 1.45,
    47: 1.48,
    48: 1.5,
    49: 1.52,
    50: 1.55,
    51: 1.57,
    52: 1.6,
    53: 1.63,
    54: 1.66,
    55: 1.68,
    56: 1.71,
    57: 1.74,
    58: 1.77,
    59: 1.8,
    60: 1.83,
  },
  [YULI_QUALITY_TYPE.GREEN]: {
    1: 3.98,
    2: 4.01,
    3: 4.05,
    4: 4.08,
    5: 4.12,
    6: 4.15,
    7: 4.19,
    8: 4.23,
    9: 4.27,
    10: 4.32,
    11: 4.36,
    12: 4.41,
    13: 4.46,
    14: 4.51,
    15: 4.56,
    16: 4.61,
    17: 4.66,
    18: 4.72,
    19: 4.77,
    20: 4.83,
    21: 4.89,
    22: 4.95,
    23: 5.02,
    24: 5.08,
    25: 5.15,
    26: 5.22,
    27: 5.29,
    28: 5.36,
    29: 5.44,
    30: 5.51,
    31: 5.59,
    32: 5.67,
    33: 5.75,
    34: 5.84,
    35: 5.92,
    36: 6.01,
    37: 6.1,
    38: 6.19,
    39: 6.29,
    40: 6.39,
    41: 6.48,
    42: 6.59,
    43: 6.69,
    44: 6.8,
    45: 6.91,
    46: 7.02,
    47: 7.14,
    48: 7.26,
    49: 7.38,
    50: 7.5,
    51: 7.63,
    52: 7.77,
    53: 7.9,
    54: 8.04,
    55: 8.18,
    56: 8.33,
    57: 8.48,
    58: 8.63,
    59: 8.78,
    60: 8.95,
  },
  [YULI_QUALITY_TYPE.BLUE]: {
    1: 19.96,
    2: 20.15,
    3: 20.35,
    4: 20.55,
    5: 20.77,
    6: 20.99,
    7: 21.21,
    8: 21.45,
    9: 21.69,
    10: 21.93,
    11: 22.19,
    12: 22.45,
    13: 22.73,
    14: 23,
    15: 23.29,
    16: 23.58,
    17: 23.88,
    18: 24.19,
    19: 24.51,
    20: 24.84,
    21: 25.18,
    22: 25.52,
    23: 25.87,
    24: 26.23,
    25: 26.6,
    26: 26.99,
    27: 27.38,
    28: 27.78,
    29: 28.19,
    30: 28.6,
    31: 29.04,
    32: 29.48,
    33: 29.94,
    34: 30.4,
    35: 30.87,
    36: 31.36,
    37: 31.86,
    38: 32.38,
    39: 32.91,
    40: 33.43,
    41: 33.99,
    42: 34.56,
    43: 35.15,
    44: 35.72,
    45: 36.34,
    46: 36.97,
    47: 37.62,
    48: 38.28,
    49: 38.94,
    50: 39.64,
    51: 40.35,
    52: 41.09,
    53: 41.81,
    54: 42.59,
    55: 43.38,
    56: 44.2,
    57: 45.03,
    58: 45.86,
    59: 46.74,
    60: 47.65,
  },
  [YULI_QUALITY_TYPE.PURPLE]: {
    1: 96.51,
    2: 97.6,
    3: 98.7,
    4: 99.86,
    5: 101.04,
    6: 102.26,
    7: 103.52,
    8: 104.81,
    9: 106.13,
    10: 107.47,
    11: 108.87,
    12: 110.3,
    13: 111.78,
    14: 113.29,
    15: 114.84,
    16: 116.44,
    17: 118.04,
    18: 119.71,
    19: 121.43,
    20: 123.2,
    21: 125.01,
    22: 126.86,
    23: 128.72,
    24: 130.67,
    25: 132.67,
    26: 134.72,
    27: 136.82,
    28: 138.91,
    29: 141.12,
    30: 143.39,
    31: 145.71,
    32: 148.09,
    33: 150.45,
    34: 152.96,
    35: 155.52,
    36: 158.15,
    37: 160.76,
    38: 163.53,
    39: 166.37,
    40: 169.28,
    41: 172.26,
    42: 175.22,
    43: 178.36,
    44: 181.58,
    45: 184.89,
    46: 188.16,
    47: 191.64,
    48: 195.22,
    49: 198.88,
    50: 202.65,
    51: 206.37,
    52: 210.34,
    53: 214.42,
    54: 218.6,
    55: 222.73,
    56: 227.15,
    57: 231.68,
    58: 236.34,
    59: 240.94,
    60: 245.86,
  },
  [YULI_QUALITY_TYPE.GOLDEN]: {
    1: 478.04,
    2: 484.06,
    3: 490.36,
    4: 496.84,
    5: 503.48,
    6: 510.3,
    7: 517.29,
    8: 524.46,
    9: 531.66,
    10: 539.22,
    11: 546.97,
    12: 554.92,
    13: 563.06,
    14: 571.41,
    15: 579.77,
    16: 588.56,
    17: 597.57,
    18: 606.8,
    19: 616.25,
    20: 625.69,
    21: 635.65,
    22: 645.85,
    23: 656.3,
    24: 667.02,
    25: 677.69,
    26: 688.96,
    27: 700.52,
    28: 712.36,
    29: 724.11,
    30: 736.58,
    31: 749.37,
    32: 762.47,
    33: 775.91,
    34: 789.24,
    35: 803.39,
    36: 817.91,
    37: 832.8,
    38: 847.52,
    39: 863.22,
    40: 879.32,
    41: 895.83,
    42: 912.77,
    43: 929.56,
    44: 947.44,
    45: 965.79,
    46: 984.62,
    47: 1003.26,
    48: 1023.15,
    49: 1043.56,
    50: 1064.53,
    51: 1085.26,
    52: 1107.42,
    53: 1130.18,
    54: 1152.61,
    55: 1176.67,
    56: 1201.41,
    57: 1226.82,
    58: 1251.87,
    59: 1278.77,
    60: 1306.42,
  },
};

/** arg消耗表*/
export const ARG_COST_MAP = {
  [YULI_QUALITY_TYPE.WHITE]: {
    [TIME_TYPE.days6]: 1503,
    [TIME_TYPE.days16]: 4007,
    [TIME_TYPE.days30]: 7513,
    [TIME_TYPE.days60]: 15026,
  },
  [YULI_QUALITY_TYPE.GREEN]: {
    [TIME_TYPE.days6]: 7477,
    [TIME_TYPE.days16]: 19940,
    [TIME_TYPE.days30]: 37387,
    [TIME_TYPE.days60]: 74774,
  },
  [YULI_QUALITY_TYPE.BLUE]: {
    [TIME_TYPE.days6]: 33917,
    [TIME_TYPE.days16]: 90444,
    [TIME_TYPE.days30]: 169583,
    [TIME_TYPE.days60]: 339166,
  },
  [YULI_QUALITY_TYPE.PURPLE]: {
    [TIME_TYPE.days6]: 151787,
    [TIME_TYPE.days16]: 404765,
    [TIME_TYPE.days30]: 758935,
    [TIME_TYPE.days60]: 1517870,
  },
  [YULI_QUALITY_TYPE.GOLDEN]: {
    [TIME_TYPE.days6]: 770231,
    [TIME_TYPE.days16]: 2053950,
    [TIME_TYPE.days30]: 3851155,
    [TIME_TYPE.days60]: 7702311,
  },
};

/**
 * 跟Yuli品质和天数获取Passcard的收益
 * @param days
 */
export const getPasscardIncomByDay = (yuli_quality, days_plan, days) => {
  try {
    const _passcard_income_map = PASSCARD_INCOME_MAP[yuli_quality] || {};
    const _passcard_income = _passcard_income_map[days_plan] || 0;

    const daily = _passcard_income / days_plan || 0;
    const income = Math.floor(daily * days);

    return income;
  } catch (error) {
    return 0;
  }
};
